<template>
  <div class="sign">
    <div class="sign-form">
      <img class="logo" src="../../assets/img/logo-new.png" alt />

      <div class="box-sign">
        <div class="box-sign-title">
          <I18Lang id="public73" defaultText="登录" />
        </div>

        <el-form :model="formData" :rules="rules" ref="formData" class="form-data">
          <el-form-item prop="account">
            <el-input name="account" autocomplete="off" auto-complete="off" v-model="formData.account"
              @blur="trimAccount" :placeholder="$t('user98')">
              <i slot="prefix" class="icon-account"></i></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input name="password" autocomplete="off" auto-complete="off" @keyup.enter.native="submitForm('formData')"
              type="password" show-password v-model.trim="formData.password" :placeholder="$t('user25')">
              <i slot="prefix" class="icon-pwd"></i></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="btn-view btn-red" @click="submitForm('formData')">
              <I18Lang id="user23" defaultText="登录" />
            </el-button>
          </el-form-item>

          <p class="foot-info">
            <router-link :to="{ name: 'findPass' }">
              <I18Lang id="public39" defaultText="找回密码" />
            </router-link>
          </p>
          <p class="foot-info">
            <I18Lang id="public42" defaultText="还没有账号？" />
            <router-link :to="{ name: 'signUp' }">
              <I18Lang id="user11" defaultText="立即注册" />
            </router-link>
          </p>

        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import cookie from '@utils/cookie'
import i18n from '@utils/i18n'
export default {
  data () {
    const validateAccount = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error(i18n.t('user98')))
      } else {
        callback()
      }
    }

    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('user25'))) // 请输入密码
      } else if (value.length < 8) {
        callback(new Error(i18n.t('public12'))) // 密码长度不能小于8位
      } else if (value.length > 16) {
        callback(new Error(i18n.t('public13'))) // 密码长度不能大于16位
      } else if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(value)) {
        callback(new Error(i18n.t('public14'))) // 必须同时包含数字和字母
      } else {
        callback()
      }
    }

    return {
      isSendCode: false,
      formData: {
        account: '',
        password: ''
      },
      rules: {
        account: [
          { required: true, validator: validateAccount, trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$t('public41'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    trimAccount () {
      this.formData.account = (this.formData.account || '').trim()
    },
    submitForm (formName) {
      // 输入过程中允许空格，登录校验前统一移除账号首尾空格
      this.trimAccount()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitSign()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitSign () {
      // 提交登录
      this.$http.post('/api/user/login', this.formData, { loading: true }).then((result) => {
        console.log('result', result)
        cookie.set('kg-client-token', result.token || '')
        this.$store.dispatch('getUserInfo').then((result) => {
          if (result.national_markets && result.national_markets.length) {
            const item = result.national_markets[0]
            cookie.set('national_market', item.id || '')
            cookie.set('national_market_currency', item.currency || '')
            localStorage.setItem('CURRENT_COUNTRY_INFO', JSON.stringify(item))
            localStorage.setItem('userInfo', JSON.stringify(result))
            this.$store.commit('SET_MARKET_ID', item.id)
            this.$store.commit('SET_NATIONAL_MARKET_CURRENCY', item.currency)
            this.$store.commit('SET_CURRENT_COUNTRY_INFO', item)
          }
          if (result.identity !== 0) {
            window.location.href = '/proxy'
          } else {
            window.location.href = '/user'
          }
        })
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped lang="scss">
.sign {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("../../assets/img/sign/bg.png") no-repeat center / 100% 100%;

  .logo {
    width: 200px;
    display: block;
    margin: 20px auto 10px;
  }

  .box-sign-title {
    font-size: 30px;
    font-family: Arial;
    font-weight: bold;
    color: #fff;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 15px;
  }

  .sign-form {

    .box-sign {
      background: rgba(255, 255, 255, 0.4);
      padding: 56px 48px;
      width: 617px;
      height: 574px;
      background: url("../../assets/img/sign/dk.png") no-repeat center / 100% 100%;
    }

    .form-data {
      width: 380px;
      margin: 40px auto 0;

      ::v-deep .el-form-item {
        margin-bottom: 40px;

        .el-input__inner {
          width: 380px;
          height: 50px;
          font-size: 16px;
          display: block;
          border-radius: 0;
          padding-left: 52px;
          color: #FFFFFF;
          background: #072433;
          border: 1px solid rgba(1, 204, 255, 0.31);

          &:focus {
            border-color: transparent;
            background: url("../../assets/img/sign/input-hover.png") no-repeat top / 100% 100%;
          }
        }

        input:-webkit-autofill {
          transition: background-color 5000s ease-out 0.5s;
          -webkit-text-fill-color: #fff;
        }
      }

      .icon-account {
        width: 40px;
        height: 40px;
        display: block;
        margin-top: 5px;
        background: url("../../assets/img/sign/z.png") no-repeat center / 100% 100%;
      }

      .icon-pwd {
        width: 40px;
        height: 40px;
        display: block;
        margin-top: 5px;
        background: url("../../assets/img/sign/m.png") no-repeat center / 100% 100%;
      }

    }

    .foot-info {
      font-size: 16px;
      color: #fff;
      letter-spacing: 0;
      text-align: center;

      a {
        width: 129px;
        height: 16px;
        font-size: 16px;
        font-family: Arial;
        font-weight: 400;
        color: #01B2F5;
        line-height: 30px;
      }
    }

    .btn-view {
      width: 100%;
      height: 52px;
      font-size: 16px;
      border-radius: 0;
      font-size: 22px;
      border: none;
      background: url("../../assets/img/sign/btn.png") no-repeat center / 100% 100%;
    }
  }
}
</style>
